/* PAPERLIKE CUSTOM — My Paperlike customer hub behaviour */
(function () {
  var root = document.querySelector("[data-pl-mypl]");
  if (!root) return;

  /* Views come from the DOM (each is a section block — hideable in the editor) */
  var VIEWS = [];
  root.querySelectorAll("[data-pl-view]").forEach(function (el) {
    VIEWS.push(el.getAttribute("data-pl-view"));
  });

  var KLAVIYO_KEY = (root.getAttribute("data-klaviyo-key") || "").trim();
  var KLAVIYO_LIST = (root.getAttribute("data-klaviyo-list") || "").trim();
  var CUSTOMER_EMAIL = (root.getAttribute("data-customer-email") || "").trim();
  var CUSTOMER_ID = (root.getAttribute("data-customer-id") || "").trim();
  var CUSTOMER_COUNTRY = (root.getAttribute("data-customer-country") || "")
    .trim()
    .toUpperCase();
  var CUSTOMER_LOCALE = (root.getAttribute("data-customer-locale") || "").trim();
  /* Klaviyo's Shopify integration stores locale as language-REGION
     ("en-DE"); Shopify's request.locale may be language-only ("en").
     Compose the same format so our write doesn't degrade an existing
     value on the standard Locale field. */
  if (CUSTOMER_LOCALE && CUSTOMER_LOCALE.indexOf("-") === -1 && CUSTOMER_COUNTRY) {
    CUSTOMER_LOCALE = CUSTOMER_LOCALE + "-" + CUSTOMER_COUNTRY;
  }

  /* Two-question personalization model (decided 2026-08-05, single value per
     group). Raw answers AND mapped segment tags are written to the Klaviyo
     profile. Usage mapping CONFIRMED by the team 2026-08-10:
     daily + weekly → AS_Heavy_User, rarely → AS_Occasional_User,
     never → AS_No_Pencil. Team convention: Klaviyo property keys are the
     human-readable "Audience Segment" / "Usage Segment" (spaces, no
     underscore — keys are exact-match, a snake_case twin would create a
     duplicate property); values use the AS_ prefix in BOTH groups. */
  var ANSWERS = {
    audience: {
      storageKey: "pl_audience",
      property: "ipad_use_case",
      segmentProperty: "Audience Segment",
      segments: {
        notes: "AS_Knowledge_Worker",
        creative: "AS_Creative_Professional",
        study: "AS_Student",
        family: "AS_Casual_Family",
        other: "AS_Other",
      },
    },
    usage: {
      storageKey: "pl_usage",
      property: "pencil_frequency",
      segmentProperty: "Usage Segment",
      segments: {
        daily: "AS_Heavy_User",
        weekly: "AS_Heavy_User",
        rarely: "AS_Occasional_User",
        never: "AS_No_Pencil",
      },
    },
  };

  /* Audience answer → preselected category pill for guides AND tools.
     Guide/tool categories ARE the Q1 buckets (team decision 2026-08-10),
     so the map is identity; "other" gets the unfiltered All tab. */
  var AUDIENCE_CATEGORY = {
    notes: "notes",
    creative: "creative",
    study: "study",
    family: "family",
    other: "all",
  };

  function klaviyoPost(path, payload, label) {
    if (!KLAVIYO_KEY || !CUSTOMER_EMAIL) {
      console.info("[pl-mypl] Klaviyo not configured, skipped:", label);
      return Promise.resolve();
    }
    return fetch(
      "https://a.klaviyo.com/client/" +
        path +
        "/?company_id=" +
        encodeURIComponent(KLAVIYO_KEY),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2026-07-15",
        },
        body: JSON.stringify(payload),
        /* Survives the page unload that follows a download/outbound click.
           sendBeacon can't be used here — a cross-origin JSON body needs a
           CORS preflight, which beacons cannot perform. */
        keepalive: true,
      }
    )
      .then(function (res) {
        if (res.ok) return;
        return res
          .json()
          .then(function (body) {
            console.warn(
              "[pl-mypl] Klaviyo " + label + " rejected (" + res.status + "):",
              JSON.stringify(body)
            );
          })
          .catch(function () {
            console.warn(
              "[pl-mypl] Klaviyo " + label + " rejected, status " + res.status
            );
          });
      })
      .catch(function (err) {
        console.warn("[pl-mypl] Klaviyo " + label + " failed:", err);
      });
  }

  function klaviyoProfileAttributes(extraProperties) {
    var attrs = { email: CUSTOMER_EMAIL };
    if (CUSTOMER_COUNTRY) attrs.location = { country: CUSTOMER_COUNTRY };
    if (CUSTOMER_LOCALE) attrs.locale = CUSTOMER_LOCALE;
    var props = extraProperties || {};
    /* Shopify customer id on the profile = ownerId for the Klaviyo-flow
       webhook that writes the customer metafields (see INSTALL.md). */
    if (CUSTOMER_ID) props.shopify_customer_id = CUSTOMER_ID;
    if (Object.keys(props).length) attrs.properties = props;
    return attrs;
  }

  /* Geo/locale sync — once per session: pushes country (order address if
     any = "correct after order", else the storefront market country =
     "optimistic before order") + storefront locale onto the Klaviyo
     profile, so EU-only lists/flows can segment on location.country and
     sends can be language-matched. Re-runs each new browser session, so
     the address country takes over after the first order. */
  if (
    KLAVIYO_KEY &&
    CUSTOMER_EMAIL &&
    (CUSTOMER_COUNTRY || CUSTOMER_LOCALE) &&
    !sessionStorage.getItem("pl_klaviyo_geo")
  ) {
    var geoProps = {};
    if (CUSTOMER_COUNTRY) geoProps.storefront_country = CUSTOMER_COUNTRY;
    if (CUSTOMER_LOCALE) geoProps.storefront_locale = CUSTOMER_LOCALE;
    klaviyoPost(
      "profiles",
      {
        data: {
          type: "profile",
          attributes: klaviyoProfileAttributes(geoProps),
        },
      },
      "geo sync"
    ).then(function () {
      sessionStorage.setItem("pl_klaviyo_geo", "1");
    });
  }

  /* ---------- View switching (hash-based) ---------- */
  var currentView = null;
  /* Set when the quiz was opened FROM another view (goodies edit link /
     nudge): saving returns there. Any manual navigation away from the
     quiz view cancels the pending return. */
  var quizReturnView = null;
  function showView(name) {
    if (!VIEWS.length) return;
    if (VIEWS.indexOf(name) === -1) name = VIEWS[0];
    /* GA sees only ONE pageview for the whole hash-switched hub — this
       event is the sub-page view counter (fires for the initial view too,
       incl. resolved defaults like the ?goodie= deep link; guarded so a
       re-render of the same view never double-counts). */
    if (name !== currentView) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "pl_mypl_view", view: name });
    }
    if (name !== "ipad") quizReturnView = null;
    root.querySelectorAll("[data-pl-view]").forEach(function (view) {
      view.hidden = view.getAttribute("data-pl-view") !== name;
    });
    root.querySelectorAll("[data-pl-nav]").forEach(function (link) {
      link.classList.toggle(
        "is-active",
        link.getAttribute("data-pl-nav") === name
      );
    });
    /* Mobile pill line: keep the active view's pill at the left content
       edge (the navbar only scrolls in the mobile layout — on desktop
       scrollWidth equals clientWidth and this is a no-op). */
    var navbar = root.querySelector("[data-pl-navbar]");
    if (navbar && navbar.scrollWidth > navbar.clientWidth + 1) {
      var activeLink = root.querySelector("[data-pl-nav].is-active");
      if (activeLink) {
        var pad = parseFloat(getComputedStyle(navbar).paddingLeft) || 0;
        navbar.scrollTo({
          left: Math.max(0, activeLink.offsetLeft - pad),
          behavior: "smooth"
        });
      }
    }
    /* Switching the sub-page mid-scroll would land the visitor in the
       middle of the new view's content. Mobile: scroll back up just far
       enough that the view's TITLE sits below the sticky stack (header +
       pill line). Desktop (sticky sidebar): plain scroll to the page top —
       sidebar and view start there anyway, no offset math needed. Only on
       an actual change (not the initial render). */
    if (currentView && currentView !== name) {
      if (window.matchMedia("(max-width: 999px)").matches) {
        scrollUpToReveal(root.querySelector('[data-pl-view="' + name + '"]'));
      } else if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
    currentView = name;
    /* Gate mode moves the quiz between views — re-place on every switch.
       (Hoisted; no-ops until the quiz block below assigned its vars.) */
    placeQuiz();
    /* Carousels measure 0 while their view is hidden — re-measure whenever
       a view becomes visible. (Hoisted; guards against the init call that
       runs before the carousels are wired.) */
    resetCarousels();
  }
  /* Scroll up just far enough that `el` sits below the sticky stack (theme
     header + mobile pill line). Never scrolls down; always reserves the
     full header height — scrolling UP re-shows the hide-on-scroll header,
     so it WILL sit there when we arrive. */
  function scrollUpToReveal(el) {
    if (!el) return;
    var headerH =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      ) || 0;
    var stickyNav = root.querySelector("[data-pl-navbar]");
    var navbarH = stickyNav ? stickyNav.offsetHeight : 0;
    var target =
      el.getBoundingClientRect().top + window.scrollY - headerH - navbarH - 8;
    if (window.scrollY > target) {
      window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    }
  }
  window.addEventListener("hashchange", function () {
    showView(location.hash.replace("#", ""));
  });
  showView(location.hash.replace("#", ""));
  /* Drops the loading spinner — from here on a view is always rendered. */
  root.setAttribute("data-pl-ready", "");

  /* ---------- Generic chip filtering ----------
     contains=true matches space-separated multi-values on the item attr.
     Returns {activate} so pills can be preselected programmatically. */
  function wireChips(chipAttr, itemAttr, contains, onFilter) {
    var chips = root.querySelectorAll("[" + chipAttr + "]");
    if (!chips.length) return null;
    function activate(value) {
      var target = null;
      chips.forEach(function (c) {
        if (c.getAttribute(chipAttr) === value) target = c;
      });
      if (!target) return;
      chips.forEach(function (c) {
        c.classList.toggle("is-active", c === target);
      });
      parkActiveChip(true);
      root.querySelectorAll("[" + itemAttr + "]").forEach(function (item) {
        var attr = item.getAttribute(itemAttr) || "";
        var match =
          value === "all" ||
          (contains
            ? (" " + attr + " ").indexOf(" " + value + " ") !== -1
            : attr === value);
        if (match) {
          item.removeAttribute("data-pl-hidden");
        } else {
          item.setAttribute("data-pl-hidden", "");
        }
      });
      if (onFilter) onFilter(value);
      /* Filtering changes the track length — jump back to the start and
         refresh the arrow states. */
      resetCarousels();
    }
    /* Mobile: the chip rows scroll horizontally (like the nav pill line) —
       park the active chip at the left content edge. Desktop rows wrap
       instead of scroll → no-op. scrollTo on a hidden row does nothing,
       so a ResizeObserver re-parks (instantly) whenever the row becomes
       visible — pending-view reveal, quiz close, view switch. */
    var chipRow = chips[0].closest(".pl-mypl__chips");
    function parkActiveChip(smooth) {
      if (!chipRow || chipRow.scrollWidth <= chipRow.clientWidth + 1) return;
      var act = null;
      chips.forEach(function (c) {
        if (c.classList.contains("is-active")) act = c;
      });
      if (!act) return;
      var pad = parseFloat(getComputedStyle(chipRow).paddingLeft) || 0;
      chipRow.scrollTo({
        left: Math.max(0, act.offsetLeft - pad),
        behavior: smooth ? "smooth" : "auto"
      });
    }
    if (chipRow && window.ResizeObserver) {
      new ResizeObserver(function () {
        parkActiveChip(false);
      }).observe(chipRow);
    }
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        activate(chip.getAttribute(chipAttr));
      });
    });
    return { activate: activate };
  }
  wireChips("data-pl-filter-orders", "data-order-status");
  /* App/tool cards carry space-separated multi-categories (an app can sit
     in several Q1 buckets) — contains-matching like the guides. */
  var appsChips = wireChips("data-pl-filter-apps", "data-app-category", true);
  var toolChips = wireChips("data-pl-filter-tools", "data-app-category", true);
  /* Category tab = exact editor-picker order. A multi-category article
     renders once at its FIRST category's track position, so a plain
     hide/show filter showed foreign order — on a specific tab the cards
     are re-appended sorted by their data-order-<cat> picker position
     (cards without one keep their relative track order, after the ordered
     ones). "All" restores the original deduped order. */
  function reorderTrack(selector, value) {
    var track = root.querySelector(selector);
    if (!track) return;
    if (!track.plOrigOrder) track.plOrigOrder = Array.prototype.slice.call(track.children);
    var orig = track.plOrigOrder;
    var sorted = orig;
    if (value !== "all") {
      sorted = orig.slice().sort(function (a, b) {
        var oa = parseInt(a.getAttribute("data-order-" + value), 10);
        var ob = parseInt(b.getAttribute("data-order-" + value), 10);
        if (isNaN(oa)) oa = 1000 + orig.indexOf(a);
        if (isNaN(ob)) ob = 1000 + orig.indexOf(b);
        return oa - ob;
      });
    }
    sorted.forEach(function (el) {
      track.appendChild(el);
    });
  }
  function reorderGuides(value) {
    reorderTrack("[data-pl-guides]", value);
  }
  var guideChips = wireChips("data-pl-filter-guides", "data-guide-cat", true, reorderGuides);
  /* Goodies shelf on Get More: same Q1-bucket chips + picker-order re-sort
     as the guides track (cards carry the same data-order-<bucket> attrs;
     a multi-bucket goodie renders once and matches every relevant chip —
     "All" shows it exactly once, in deduped track order). */
  var gshelfChips = wireChips("data-pl-filter-gshelf", "data-gshelf-cat", true, function (value) {
    reorderTrack("[data-pl-gshelf]", value);
  });
  /* ONE visible filter row on Get More (2026-08-19): the combined
     --getmore chips below the rec heading drive all three shelves at
     once. The per-shelf rows stay in the DOM as the actual filter
     engines (CSS hides them; every activation is mirrored into them).
     The row's own item attribute matches nothing — it filters only via
     the cascade. */
  var getmoreChips = wireChips("data-pl-filter-getmore", "data-pl-getmore-none", true, function (value) {
    if (guideChips) guideChips.activate(value);
    if (gshelfChips) gshelfChips.activate(value);
    if (toolChips) toolChips.activate(value);
  });
  /* A USER click on the combined row scrolls back up until the first
     shelf sits right below the sticky stack (header + mobile navbar +
     the row itself) — same mechanics as the goodies chips; programmatic
     activate() (quiz preselect) never scrolls. */
  function scrollGetmoreIntoView() {
    var first = root.querySelector('[data-pl-view="ipad"] .pl-mypl__rec-section');
    if (!first) return;
    var headerH =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      ) || 0;
    var gmNavbar = root.querySelector("[data-pl-navbar]");
    var navbarH = gmNavbar ? gmNavbar.offsetHeight : 0;
    var gmChips = root.querySelector(".pl-mypl__chips--getmore");
    var chipsH = gmChips ? gmChips.offsetHeight : 0;
    var target =
      first.getBoundingClientRect().top + window.scrollY - headerH - navbarH - chipsH - 8;
    if (window.scrollY > target) {
      window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    }
  }
  root.querySelectorAll("[data-pl-filter-getmore]").forEach(function (chip) {
    chip.addEventListener("click", scrollGetmoreIntoView);
  });
  /* Goodie chips: dynamic categories (handleized display labels on
     data-goodie-cats) + a "Recommended" tab fed by per-bucket editor picks.
     "recommended" matches no cats value, so wireChips first hides every
     card — the onFilter below re-shows the ones picked for the CURRENT
     audience bucket and sorts them into exact picker order (same
     re-append trick as the guide tabs). */
  function audienceBucket() {
    var v = currentAnswer("audience");
    return v && v !== "other" ? v : "";
  }
  function reorderGoodies(bucket) {
    var grid = root.querySelector("[data-pl-goodies-grid]");
    if (!grid) return;
    if (!grid.plOrigOrder) grid.plOrigOrder = Array.prototype.slice.call(grid.children);
    var orig = grid.plOrigOrder;
    var sorted = orig;
    if (bucket) {
      sorted = orig.slice().sort(function (a, b) {
        var oa = parseInt(a.getAttribute("data-gorder-" + bucket), 10);
        var ob = parseInt(b.getAttribute("data-gorder-" + bucket), 10);
        if (isNaN(oa)) oa = 1000 + orig.indexOf(a);
        if (isNaN(ob)) ob = 1000 + orig.indexOf(b);
        return oa - ob;
      });
    }
    sorted.forEach(function (el) {
      grid.appendChild(el);
    });
  }
  /* The goodies chip row is sticky below the header (+ pill navbar on
     mobile) — the navbar's height feeds the CSS top offset. On desktop
     the navbar is display:contents (height 0) and the var stays unused. */
  var navbarEl = root.querySelector("[data-pl-navbar]");
  if (navbarEl && window.ResizeObserver) {
    new ResizeObserver(function () {
      root.style.setProperty("--pl-navbar-h", navbarEl.offsetHeight + "px");
    }).observe(navbarEl);
  }
  var goodieChips = wireChips("data-pl-filter-goodies", "data-goodie-cats", true, function (value) {
    if (value === "recommended") {
      var bucket = audienceBucket();
      root.querySelectorAll("[data-goodie-rec]").forEach(function (card) {
        var rec = " " + card.getAttribute("data-goodie-rec") + " ";
        if (bucket && rec.indexOf(" " + bucket + " ") !== -1) {
          card.removeAttribute("data-pl-hidden");
        }
      });
      reorderGoodies(bucket);
    } else {
      reorderGoodies("");
    }
  });
  /* The Recommended chip only exists once a bucket has picks (Liquid) and
     only SHOWS when the visitor's bucket is one of them — then it becomes
     the default tab (mirrors the guides/tools preselection). Losing the
     bucket (answer changed to "other") falls back to All. */
  /* USER clicks on a goodies tab scroll back up JUST far enough that the
     whole grid is visible below the sticky stack (header + mobile navbar
     + the sticky chip row itself) — i.e. to the point where the chips
     have only just stuck. NOT to the page top: search bar / quiz nudge
     may stay hidden above. Never scrolls down. Own listener on purpose —
     wireChips' activate() also fires programmatically (init preselect,
     search snap-to-All) and must never scroll. */
  function scrollGoodiesGridIntoView() {
    var grid = root.querySelector("[data-pl-goodies-grid]");
    if (!grid) return;
    var headerH =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      ) || 0;
    var gNavbar = root.querySelector("[data-pl-navbar]");
    var navbarH = gNavbar ? gNavbar.offsetHeight : 0;
    var gChips = root.querySelector('[data-pl-view="goodies"] .pl-mypl__chips');
    var chipsH = gChips ? gChips.offsetHeight : 0;
    var target =
      grid.getBoundingClientRect().top + window.scrollY - headerH - navbarH - chipsH - 8;
    if (window.scrollY > target) {
      window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    }
  }
  root.querySelectorAll("[data-pl-filter-goodies]").forEach(function (chip) {
    chip.addEventListener("click", scrollGoodiesGridIntoView);
  });
  /* Same behavior for My Products: a status-chip click scrolls up until
     the order list starts right below the sticky stack. The chip row is
     the region's first in-flow child, so its height cancels out of the
     math — the region top itself is the anchor. Delegated listener: the
     background swap REPLACES the chips, direct listeners would be lost. */
  function scrollOrdersListIntoView() {
    var region = root.querySelector("[data-pl-orders-region]");
    if (!region) return;
    var headerH =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      ) || 0;
    var oNavbar = root.querySelector("[data-pl-navbar]");
    var navbarH = oNavbar ? oNavbar.offsetHeight : 0;
    var target = region.getBoundingClientRect().top + window.scrollY - headerH - navbarH - 8;
    if (window.scrollY > target) {
      window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    }
  }
  root.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-pl-filter-orders]")) {
      scrollOrdersListIntoView();
    }
  });
  var goodieRecChip = root.querySelector('[data-pl-filter-goodies="recommended"]');
  /* True while the ?goodie= deep-link spotlight is showing — the visitor
     landed FOR this goodie, so the Recommended preselect must not switch
     to a tab that could hide it. Cleared on the first interaction. */
  var goodieSpotlight = false;
  function goodieSearchActive() {
    var el = root.querySelector("[data-pl-goodie-search]");
    return !!el && el.value.trim().length >= 3;
  }
  function updateGoodieRecChip(value) {
    if (!goodieRecChip || !goodieChips) return;
    var avail = " " + (goodieRecChip.getAttribute("data-pl-goodies-rec-avail") || "") + " ";
    var bucket = value && value !== "other" ? value : "";
    var usable = !!bucket && avail.indexOf(" " + bucket + " ") !== -1;
    goodieRecChip.hidden = !usable;
    /* An active name search means All (search = "across all goodies") —
       don't let the audience-answer auto-select clobber it; same for the
       deep-link spotlight. The chip still becomes visible for later. */
    if (usable && !goodieSearchActive() && !goodieSpotlight) {
      goodieChips.activate("recommended");
    } else if (!usable && goodieRecChip.classList.contains("is-active")) {
      goodieChips.activate("all");
    }
  }
  /* The apps view and the tools shelf filter the SAME cards attribute —
     clicking a tab in one keeps the other's tab row in sync. */
  if (appsChips && toolChips) {
    root.querySelectorAll("[data-pl-filter-apps]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        toolChips.activate(chip.getAttribute("data-pl-filter-apps"));
      });
    });
    root.querySelectorAll("[data-pl-filter-tools]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        appsChips.activate(chip.getAttribute("data-pl-filter-tools"));
      });
    });
  }

  /* Recommended-tools shelf is alphabetical (the "All" tab contract) —
     sorted once here, so every category filter stays alphabetical too. */
  var toolsTrack = root.querySelector("[data-pl-tools]");
  if (toolsTrack) {
    Array.prototype.slice
      .call(toolsTrack.children)
      .sort(function (a, b) {
        var ta = a.querySelector(".pl-mypl__card-title");
        var tb = b.querySelector(".pl-mypl__card-title");
        return (ta ? ta.textContent : "").localeCompare(tb ? tb.textContent : "");
      })
      .forEach(function (el) {
        toolsTrack.appendChild(el);
      });
  }

  /* ---------- Goodie name search ----------
     Replaces the old tab filter: live-filters the goodie grid from 3 typed
     characters; below that everything shows again. */
  var goodieSearch = root.querySelector("[data-pl-goodie-search]");
  if (goodieSearch) {
    var goodieCards = root.querySelectorAll(
      "[data-pl-goodies-grid] [data-goodie-name]"
    );
    var goodieNoResults = root.querySelector("[data-pl-goodie-noresults]");
    var goodieSearchClear = root.querySelector("[data-pl-goodie-search-clear]");
    /* Forgiving matching (2026-08-18): hyphens/punctuation/casing are
       normalized away on BOTH sides, and every typed word just has to
       appear somewhere in the name (order-free). Each word is also
       tested against the name with all spaces removed, so "brushset"
       still finds "Brush Set" and "10 ways" finds "10-Ways". */
    function normalizeSearch(s) {
      return s
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, " ")
        .trim()
        .replace(/\s+/g, " ");
    }
    goodieCards.forEach(function (card) {
      var norm = normalizeSearch(card.getAttribute("data-goodie-name") || "");
      card.plSearchName = norm;
      card.plSearchCompact = norm.replace(/ /g, "");
    });
    function goodieMatches(card, q) {
      var tokens = q.split(" ");
      for (var i = 0; i < tokens.length; i++) {
        if (
          card.plSearchName.indexOf(tokens[i]) === -1 &&
          card.plSearchCompact.indexOf(tokens[i]) === -1
        ) {
          return false;
        }
      }
      return true;
    }
    goodieSearch.addEventListener("input", function () {
      if (goodieSearchClear) goodieSearchClear.hidden = goodieSearch.value.length === 0;
      var q = normalizeSearch(goodieSearch.value);
      var active = q.length >= 3;
      /* Search means "across ALL goodies" — an active category/Recommended
         chip would silently hide matches, so it snaps back to All. Own
         attribute (not data-pl-hidden): the chip filter and the search
         must not clobber each other's state. */
      if (active && goodieChips) {
        var allChip = root.querySelector('[data-pl-filter-goodies="all"]');
        if (allChip && !allChip.classList.contains("is-active")) {
          goodieChips.activate("all");
        }
      }
      var hits = 0;
      goodieCards.forEach(function (card) {
        var match = !active || goodieMatches(card, q);
        if (match) {
          card.removeAttribute("data-pl-search-hidden");
          hits++;
        } else {
          card.setAttribute("data-pl-search-hidden", "");
        }
      });
      if (goodieNoResults) goodieNoResults.hidden = !active || hits > 0;
    });
    if (goodieSearchClear) {
      goodieSearchClear.addEventListener("click", function () {
        goodieSearch.value = "";
        goodieSearch.dispatchEvent(new Event("input", { bubbles: true }));
        goodieSearch.focus();
      });
    }
    /* Deep link from the SEO goodie pages: ?goodie=<name> — SPOTLIGHT
       (2026-08-19, replaces the search prefill, which hid every other
       goodie): the matched card moves to position 1 in the grid and gets
       an outline; the All tab is forced active so the card is guaranteed
       visible (goodieSpotlight also blocks the later Recommended
       preselect). The outline fades on the first interaction — typing in
       the search or a chip click — while the position keeps for the page
       view: undoing it would fight the plOrigOrder cache for no gain.
       This block runs BEFORE the first reorderGoodies call, so the
       prepended order IS the cached "original" and survives
       Recommended→All round trips. No match → plain default view.
       The inline first-paint script normally does the match + prepend +
       outline already (visitors from a goodie link see the highlight
       before this file even loads) — here it's picked up by class and
       only the behavior is wired; the own match below is the fallback. */
    var goodieParam = "";
    try {
      goodieParam = new URLSearchParams(location.search).get("goodie") || "";
    } catch (e) { /* old browsers: no spotlight */ }
    if (goodieParam) {
      var spotCard = root.querySelector(".pl-mypl__card--spotlight");
      if (!spotCard) {
        var spotQ = normalizeSearch(goodieParam);
        if (spotQ.length >= 3) {
          for (var si = 0; si < goodieCards.length; si++) {
            if (goodieMatches(goodieCards[si], spotQ)) {
              spotCard = goodieCards[si];
              break;
            }
          }
        }
        if (spotCard) {
          var spotGrid = root.querySelector("[data-pl-goodies-grid]");
          spotGrid.insertBefore(spotCard, spotGrid.firstChild);
          spotCard.classList.add("pl-mypl__card--spotlight");
        }
      }
      if (spotCard) {
        goodieSpotlight = true;
        if (goodieChips) goodieChips.activate("all");
        var spotlightOff = function () {
          goodieSpotlight = false;
          spotCard.classList.add("pl-mypl__card--spotlight-off");
          goodieSearch.removeEventListener("input", spotlightOff);
        };
        goodieSearch.addEventListener("input", spotlightOff);
        root.querySelectorAll("[data-pl-filter-goodies]").forEach(function (chip) {
          chip.addEventListener("click", spotlightOff);
        });
      }
      if ((location.hash || "").replace("#", "") !== "goodies") {
        location.hash = "#goodies";
      }
    }
  }

  /* ---------- Free info dot → consent prompt ----------
     Only rendered while the customer hasn't accepted marketing (the prompt
     exists then); scrolls up to the "Don't miss new goodies" box. */
  root.querySelectorAll("[data-pl-goodie-consent-hint]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      scrollUpToReveal(root.querySelector(".pl-mypl__consent"));
    });
  });

  /* ---------- Card carousels (guides + recommended tools) ----------
     Scroll-snap tracks with prev/next arrows: one card per click, arrows
     fade at the ends, hidden entirely when everything already fits. */
  var carousels = [];
  function resetCarousels() {
    (carousels || []).forEach(function (c) {
      c.reset();
    });
  }
  root.querySelectorAll("[data-pl-carousel]").forEach(function (carousel) {
    var track = carousel.querySelector("[data-pl-track]");
    var prev = carousel.querySelector("[data-pl-carousel-prev]");
    var next = carousel.querySelector("[data-pl-carousel-next]");
    if (!track || !prev || !next) return;
    /* No `disabled` attribute: WebKit skips disabled buttons in hit
       testing, so clicks fell straight through the faded arrow onto the
       card underneath. A class + handler guard keeps the invisible button
       a real click target. */
    function setInactive(btn, state) {
      btn.classList.toggle("is-inactive", state);
      if (state) {
        btn.setAttribute("aria-disabled", "true");
      } else {
        btn.removeAttribute("aria-disabled");
      }
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      carousel.toggleAttribute("data-scrollable", max > 1);
      setInactive(prev, track.scrollLeft <= 1);
      setInactive(next, track.scrollLeft >= max - 1);
    }
    function step() {
      var card = null;
      Array.prototype.forEach.call(track.children, function (el) {
        if (!card && !el.hasAttribute("data-pl-hidden")) card = el;
      });
      var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }
    prev.addEventListener("click", function () {
      if (prev.classList.contains("is-inactive")) return;
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      if (next.classList.contains("is-inactive")) return;
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    /* A track inside a hidden view/area measures 0 at init ("not
       scrollable" → no arrows until something re-measured). The observer
       fires the moment the track gets real dimensions — whatever revealed
       it (view switch, quiz/rec toggle, images, fonts). */
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    }
    update();
    carousels.push({
      reset: function () {
        track.scrollTo({ left: 0 });
        update();
      },
    });
  });

  /* ---------- Two-question picker ---------- */
  function reverseSegment(config, segment) {
    if (!segment) return "";
    for (var key in config.segments) {
      if (config.segments[key] === segment) return key;
    }
    return "";
  }

  /* ---------- Unanswered preview (?pl_preview=unanswered) ----------
     Lets an already-segmented account inspect the unanswered state (nudge,
     hard gate, open quiz) without switching accounts: answers read as
     empty and quiz clicks stay in memory only — localStorage, Klaviyo and
     the metafield seeds are never written, so the real profile stays
     untouched and a plain reload without the param leaves preview. */
  var PREVIEW_UNANSWERED = false;
  try {
    PREVIEW_UNANSWERED =
      new URLSearchParams(location.search).get("pl_preview") === "unanswered";
  } catch (e) { /* no URLSearchParams: no preview */ }
  var previewAnswers = {};
  if (PREVIEW_UNANSWERED && window.console && console.info) {
    console.info("[pl-mypl] preview: quiz reads as unanswered, no writes");
  }

  /* Storage keys are scoped per customer — a browser-global key leaked the
     previous account's answers into a fresh account on the same device. */
  function answerStorageKey(question) {
    return ANSWERS[question].storageKey + "_" + (CUSTOMER_ID || "anon");
  }

  /* Local answers carry a write timestamp: within this window a local
     answer beats a DIFFERENT metafield value (the Klaviyo→Shopify sync
     needs seconds to minutes, so right after answering the metafield is
     briefly stale). After the window the metafield is the cross-device
     truth — it wins and refreshes the local copy. */
  var ANSWER_GRACE_MS = 30 * 60 * 1000;
  function currentAnswer(question) {
    if (PREVIEW_UNANSWERED) return previewAnswers[question] || "";
    var cfg = ANSWERS[question];
    var key = answerStorageKey(question);
    var stored = localStorage.getItem(key);
    /* Metafield seed (Klaviyo sync writes it) — holds the segment tag,
       map it back to the answer key. */
    var seedRaw = (root.getAttribute("data-" + question + "-seed") || "").trim();
    var seed = reverseSegment(cfg, seedRaw);
    /* Conflict = the SEGMENTS differ, not the answer keys: two answers can
       share one segment (daily/weekly → AS_Heavy_User) and the metafield
       round-trip loses that precision — when the segment agrees, the more
       precise local answer stays, regardless of age. */
    if (stored && seed && cfg.segments[stored] !== seedRaw) {
      var t = parseInt(localStorage.getItem(key + "_t"), 10);
      var localIsFresh = !isNaN(t) && Date.now() - t < ANSWER_GRACE_MS;
      if (!localIsFresh) {
        localStorage.setItem(key, seed);
        return seed;
      }
    }
    if (stored) return stored;
    return seed;
  }

  /* Tag next to "Recommended Content for you" — mirrors the Q1 answer
     label in that option's picker-icon colour. Hidden while unanswered AND
     for "other" (an "Other" badge reads odd — team decision 2026-08-10). */
  var AUDIENCE_BADGE = {
    notes: "yellow",
    creative: "purple",
    study: "blue",
    family: "green",
  };
  var recBadges = root.querySelectorAll("[data-pl-rec-badge]");
  function updateRecBadge(value) {
    if (!recBadges.length) return;
    var color = AUDIENCE_BADGE[value];
    var label = value
      ? root.querySelector(
          '[data-pl-answer="audience"][data-pl-value="' +
            value +
            '"] .pl-mypl__picker-label'
        )
      : null;
    /* One badge per view (Get More rec heading + goodies title) — same
       data attr, same content. */
    recBadges.forEach(function (badge) {
      if (label && color) {
        badge.textContent = label.textContent;
        badge.className = "pl-mypl__pill pl-mypl__pill--" + color;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });
  }

  function applyAnswer(question, value) {
    root
      .querySelectorAll('[data-pl-answer="' + question + '"]')
      .forEach(function (card) {
        var selected = card.getAttribute("data-pl-value") === value;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
      });
    if (question === "audience") {
      updateRecBadge(value);
      /* Preselect the matching tab everywhere the categories appear —
         the combined Get More row cascades into the guide/goodies-shelf/
         tools engines; the apps view keeps its own row. */
      if (AUDIENCE_CATEGORY[value]) {
        if (getmoreChips) {
          getmoreChips.activate(AUDIENCE_CATEGORY[value]);
        } else {
          if (guideChips) guideChips.activate(AUDIENCE_CATEGORY[value]);
          if (gshelfChips) gshelfChips.activate(AUDIENCE_CATEGORY[value]);
          if (toolChips) toolChips.activate(AUDIENCE_CATEGORY[value]);
        }
        if (appsChips) appsChips.activate(AUDIENCE_CATEGORY[value]);
      }
      updateGoodieRecChip(value);
    }
  }

  /* Profile-only Klaviyo sync (single value per group): upsert by email,
     properties merged directly — no list binding, no consent side effects.
     Debounced per question so rapid switching only sends the final choice.
     BACKLOG: targeted list binding via client/subscriptions is documented
     in LEARNINGS.md / INSTALL.md; the unused List ID setting is reserved. */
  var syncTimers = {};
  function plSyncAnswer(question, value) {
    window.clearTimeout(syncTimers[question]);
    syncTimers[question] = window.setTimeout(function () {
      var cfg = ANSWERS[question];
      var props = {};
      props[cfg.property] = value;
      if (cfg.segments[value]) props[cfg.segmentProperty] = cfg.segments[value];
      klaviyoPost(
        "profiles",
        {
          data: {
            type: "profile",
            attributes: klaviyoProfileAttributes(props),
          },
        },
        question + " profile update"
      );
      /* Metric event — first-class Klaviyo flow trigger (fires on every
         change) for the metafield bridge. The flow webhook should read the
         CURRENT profile properties, not this event's payload. */
      klaviyoPost(
        "events",
        {
          data: {
            type: "event",
            attributes: {
              properties: {
                question: question,
                answer: value,
                segment: cfg.segments[value] || "",
              },
              metric: {
                data: {
                  type: "metric",
                  attributes: { name: "Personalization Question Answered" },
                },
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: klaviyoProfileAttributes(),
                },
              },
            },
          },
        },
        question + " event"
      );
    }, 800);
  }

  root.querySelectorAll("[data-pl-answer]").forEach(function (card) {
    card.addEventListener("click", function () {
      var question = card.getAttribute("data-pl-answer");
      var value = card.getAttribute("data-pl-value");
      if (PREVIEW_UNANSWERED) {
        /* Walk the whole flow (incl. gate reveal) without any writes. */
        previewAnswers[question] = value;
        applyAnswer(question, value);
        updateQuizVisibility();
        return;
      }
      localStorage.setItem(answerStorageKey(question), value);
      localStorage.setItem(answerStorageKey(question) + "_t", String(Date.now()));
      applyAnswer(question, value);
      plSyncAnswer(question, value);
      /* No auto-close on completion (changed 2026-08-12): completing both
         questions reveals the Save link + the big "Update preferences"
         button, and THOSE close the quiz — initial mode behaves exactly
         like edit mode, in the goodies hard gate too (decision 2026-08-31:
         an instant reveal felt abrupt — the visitor confirms via Save, and
         placeQuiz keeps the gate until the session closes). (Hoisted
         function declarations — the quiz block below runs before any click
         can happen.) */
      updateQuizVisibility();
    });
  });
  applyAnswer("audience", currentAnswer("audience"));
  applyAnswer("usage", currentAnswer("usage"));

  /* ---------- Quiz visibility ----------
     Quiz box and recommendations area are mutually exclusive: unanswered or
     edit mode → quiz shows, recommendations hide; answered AND closed →
     quiz retires, recommendations show. "Edit preferences" (in the rec
     heading) opens the quiz again; the Save link / "Update preferences"
     button (visible once both questions are answered — in the INITIAL run
     too) close it. Answer changes never auto-close. */
  var quiz = root.querySelector("[data-pl-quiz]");
  var recContent = root.querySelector("[data-pl-rec-content]");
  var editPrefs = root.querySelector("[data-pl-edit-prefs]");
  var quizDoneBtns = root.querySelectorAll("[data-pl-quiz-done]");
  /* Goodies-view companions (both jump to the ONE quiz on Get More): the
     nudge banner shows while unanswered (and not snoozed via its X), the
     edit link once answered. Snooze = 7 days: long enough not to nag on
     every visit, short enough that undecided visitors get re-nudged. */
  var goodiesQuizHint = root.querySelector("[data-pl-goodies-quiz-hint]");
  var goodiesEditPrefs = root.querySelector("[data-pl-goodies-edit-prefs]");
  /* quiz_mode=gate: the mount only renders in gate mode. While unanswered
     AND the goodies view is active, the ONE quiz node moves into the
     mount (same node, same listeners — no duplicated state); on Get More,
     or once answered, it sits back at its home slot before the rec
     content. is-quiz-gated on the goodies view hides the goodies content
     (Liquid pre-sets it from the metafield seeds; localStorage wins
     here). The nudge banner never shows in gate mode. */
  var goodiesGateMount = root.querySelector("[data-pl-goodies-quiz-mount]");
  var goodiesGateView = root.querySelector('[data-pl-view="goodies"]');
  var quizHome = quiz ? quiz.parentNode : null;
  var quizHomeNext = quiz ? quiz.nextElementSibling : null;
  var NUDGE_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
  var nudgeSnoozeKey = "pl_goodie_nudge_snooze_" + (CUSTOMER_ID || "anon");
  function nudgeSnoozed() {
    /* Preview must show the nudge even if this browser snoozed it. */
    if (PREVIEW_UNANSWERED) return false;
    var t = parseInt(localStorage.getItem(nudgeSnoozeKey), 10);
    return !isNaN(t) && Date.now() - t < NUDGE_SNOOZE_MS;
  }
  /* Unanswered on load = the initial run counts as an open edit session,
     so completing it shows the close buttons instead of auto-retiring. */
  var quizEditOpen = !isAnswered();
  function isAnswered() {
    return !!(currentAnswer("audience") && currentAnswer("usage"));
  }
  /* Hoisted — showView calls it on every view switch (no-op until the
     quiz block's vars above are assigned, and entirely in hint mode).
     The gate holds until the visitor actively closes the quiz (decision
     2026-08-31: revealing on the second answer felt abrupt): unanswered →
     gate; answered but the session that STARTED in the gate still open
     (node still in the mount) → gate stays until Save/Update. An edit
     session opened on Get More never drags the quiz into goodies — the
     answered check plus the node-location check keep it home. */
  function placeQuiz() {
    if (!goodiesGateMount || !quiz || !quizHome) return;
    var inMount = quiz.parentNode === goodiesGateMount;
    var gate =
      currentView === "goodies" &&
      (!isAnswered() || (quizEditOpen && inMount));
    if (gate && !inMount) {
      goodiesGateMount.appendChild(quiz);
    } else if (!gate && quiz.parentNode !== quizHome) {
      quizHome.insertBefore(quiz, quizHomeNext);
    }
    goodiesGateMount.hidden = !gate;
    if (goodiesGateView) {
      goodiesGateView.classList.toggle("is-quiz-gated", gate);
    }
  }
  function updateQuizVisibility() {
    var answered = isAnswered();
    var quizVisible = !answered || quizEditOpen;
    placeQuiz();
    if (quiz) quiz.hidden = !quizVisible;
    if (recContent) recContent.hidden = quizVisible;
    if (editPrefs) editPrefs.hidden = !answered;
    if (goodiesQuizHint) goodiesQuizHint.hidden = answered || nudgeSnoozed() || !!goodiesGateMount;
    if (goodiesEditPrefs) goodiesEditPrefs.hidden = !answered;
    /* Content-aware Get More intro: both paragraphs only render when the
       answered-variant setting is filled — otherwise the default intro
       has no toggle attr and simply stays. */
    var introDefault = root.querySelector("[data-pl-intro-default]");
    var introAnswered = root.querySelector("[data-pl-intro-answered]");
    if (introDefault) introDefault.hidden = answered;
    if (introAnswered) introAnswered.hidden = !answered;
    quizDoneBtns.forEach(function (btn) {
      btn.hidden = !answered;
    });
  }
  if (editPrefs) {
    editPrefs.addEventListener("click", function () {
      quizEditOpen = true;
      updateQuizVisibility();
      /* scrollUpToReveal, NOT scrollIntoView: it only ever scrolls UP and
         respects the sticky stack — scrollIntoView nudged the page slightly
         down on mobile. */
      scrollUpToReveal(quiz);
    });
  }
  /* Jump from goodies → the quiz on Get More: open the edit session first,
     then the hash change runs showView with its usual scroll behavior. */
  function jumpToQuiz() {
    if (VIEWS.indexOf("ipad") === -1) return;
    quizEditOpen = true;
    updateQuizVisibility();
    /* Remember where we came from — Save brings the visitor back. Assign
       AFTER the flag reset in showView would have run is not needed:
       showView only clears it for non-ipad targets, and we're heading to
       ipad. */
    var origin = currentView !== "ipad" ? currentView : null;
    if (location.hash === "#ipad") {
      showView("ipad");
    } else {
      location.hash = "#ipad";
    }
    quizReturnView = origin;
  }
  var goodiesQuizJump = root.querySelector("[data-pl-goodies-quiz-jump]");
  var goodiesQuizDismiss = root.querySelector("[data-pl-goodies-quiz-dismiss]");
  if (goodiesQuizJump) goodiesQuizJump.addEventListener("click", jumpToQuiz);
  if (goodiesQuizDismiss) {
    goodiesQuizDismiss.addEventListener("click", function () {
      /* Preview: hide for this page view only — never write the real
         snooze from a preview session. */
      if (!PREVIEW_UNANSWERED) {
        try { localStorage.setItem(nudgeSnoozeKey, String(Date.now())); } catch (e) { /* private mode */ }
      }
      goodiesQuizHint.classList.add("is-leaving");
      window.setTimeout(function () { goodiesQuizHint.hidden = true; }, 450);
    });
  }
  if (goodiesEditPrefs) goodiesEditPrefs.addEventListener("click", jumpToQuiz);
  quizDoneBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      /* Resolve the owning view BEFORE updateQuizVisibility — in gate
         mode it moves the quiz back to Get More, and btn.closest would
         then point at the hidden ipad view instead of where we stand. */
      var ownerView = btn.closest("[data-pl-view]");
      quizEditOpen = false;
      updateQuizVisibility();
      /* Opened from another view (goodies edit link / nudge)? Save goes
         back there — the hashchange runs showView incl. its scroll. */
      if (quizReturnView) {
        var back = quizReturnView;
        quizReturnView = null;
        location.hash = "#" + back;
        return;
      }
      /* Closing from the bottom of the quiz can leave the visitor
         mid-content — same scroll behavior as a view switch: mobile back
         up to the view title (below the sticky stack), desktop to the
         page top. */
      if (window.matchMedia("(max-width: 999px)").matches) {
        scrollUpToReveal(ownerView);
      } else if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  });
  updateQuizVisibility();

  /* ---------- Favorite-app click tracking (Klaviyo metric + dataLayer) ---------- */
  root.querySelectorAll("[data-pl-app-click]").forEach(function (link) {
    link.addEventListener("click", function () {
      var appName = link.getAttribute("data-pl-app-click");
      /* view = where the click happened ("ipad" = tools shelf on Get
         More, "apps" = the apps view) — dataLayer only, the Klaviyo
         metric payload stays as communicated. */
      var appView = link.closest("[data-pl-view]");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pl_favorite_app_click",
        app_name: appName,
        view: appView ? appView.getAttribute("data-pl-view") : "",
      });
      klaviyoPost(
        "events",
        {
          data: {
            type: "event",
            attributes: {
              properties: {
                app_name: appName,
                country: CUSTOMER_COUNTRY || "unknown",
              },
              metric: {
                data: {
                  type: "metric",
                  attributes: { name: "Favorite App Clicked" },
                },
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: klaviyoProfileAttributes(),
                },
              },
            },
          },
        },
        "app click event"
      );
    });
  });

  /* ---------- Guide (blog article) click tracking (dataLayer only) ----------
     For the account-page analytics view — no Klaviyo metric (not needed
     for flows). article_url is the storefront-relative path. */
  root.querySelectorAll("[data-pl-guide-click]").forEach(function (link) {
    link.addEventListener("click", function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pl_guide_click",
        article_title: link.getAttribute("data-pl-guide-click"),
        article_url: link.getAttribute("href"),
      });
    });
  });

  /* ---------- Goodie download click tracking (Klaviyo metric + dataLayer) ----------
     ONE metric for all goodies, the handle carried as an event property —
     not one metric per goodie. Flows trigger on "Goodie Downloaded" and
     narrow with a trigger filter on `goodie`, which keeps the metric list
     finite and lets segments ask "downloaded X at least once".
     Events are append-only in Klaviyo: clicking twice logs twice, nothing
     is overwritten. The "when was it last downloaded" question is answered
     by the profile properties below, which DO overwrite. */
  root.querySelectorAll("[data-pl-goodie-download]").forEach(function (link) {
    link.addEventListener("click", function () {
      var handle = link.getAttribute("data-pl-goodie-download");
      var title = link.getAttribute("data-pl-goodie-title") || handle;
      var goodieId = "goodie-" + handle;
      var now = new Date().toISOString();

      /* view = "goodies" (main grid) or "ipad" (shelf on Get More). */
      var dlView = link.closest("[data-pl-view]");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pl_goodie_download",
        goodie_handle: handle,
        goodie_name: title,
        view: dlView ? dlView.getAttribute("data-pl-view") : "",
      });

      klaviyoPost(
        "events",
        {
          data: {
            type: "event",
            attributes: {
              properties: {
                goodie: handle,
                goodie_id: goodieId,
                goodie_name: title,
                downloaded_at: now,
                country: CUSTOMER_COUNTRY || "unknown",
              },
              metric: {
                data: {
                  type: "metric",
                  attributes: { name: "Goodie Downloaded" },
                },
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: klaviyoProfileAttributes(),
                },
              },
            },
          },
        },
        "goodie download event"
      );

      /* Cumulative history only — this is what syncs into the Shopify list
         metafield and drives the page. "Most recent download" needs no
         property: the event above already carries handle + timestamp, so a
         segment can ask "has done Goodie Downloaded in the last 30 days".
         Append is a server-side merge, so two devices cannot clobber each
         other and we never read-modify-write a metafield that lags by up
         to 30 minutes. */
      klaviyoPost(
        "profiles",
        {
          data: {
            type: "profile",
            attributes: klaviyoProfileAttributes(),
            meta: {
              patch_properties: {
                append: { "Downloaded Goodies": handle },
              },
            },
          },
        },
        "goodie download profile update"
      );
    });
  });

  /* ---------- Marketing consent toggle ----------
     Two writes from one opt-in:
     1. Klaviyo master-list subscription (list ID from the section setting)
        via POST /client/subscriptions/ — this is what arms the list's
        double opt-in flow; until confirmed the profile sits on the list as
        "pending", so goodie follow-up flows can nudge the confirm.
     2. The Shopify customer form (accepts_marketing) — submitted after a
        short delay; klaviyoPost's keepalive lets the request outlive the
        navigation the submit causes. */
  var consentToggle = root.querySelector("[data-pl-consent-toggle]");
  if (consentToggle) {
    var plConsentSave = function () {
      if (!consentToggle.checked) return;
      var form = consentToggle.closest("form");
      var label = consentToggle.closest(".pl-mypl__toggle");
      /* No text swap — both texts are pre-rendered stacked in one grid
         cell (see the section markup), so this can't reflow the row. */
      if (label) label.classList.add("is-saving");
      if (KLAVIYO_LIST) {
        klaviyoPost(
          "subscriptions",
          {
            data: {
              type: "subscription",
              attributes: {
                custom_source: "My Paperlike consent prompt",
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: CUSTOMER_EMAIL },
                  },
                },
              },
              relationships: {
                list: { data: { type: "list", id: KLAVIYO_LIST } },
              },
            },
          },
          "master list subscription"
        );
      }
      /* The form's return_to is rendered from request.path — the #view
         hash never reaches the server, so the reload landed on the
         default view. Append the current hash so the visitor stays on
         the subpage they subscribed from. */
      var returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo && location.hash) {
        returnTo.value = returnTo.value.split("#")[0] + location.hash;
      }
      window.setTimeout(function () {
        /* Flag for the post-reload success box — the reload renders with
           accepts_marketing = true, which removes the whole prompt, so the
           success text can only be shown by the next page load. */
        try { sessionStorage.setItem("plConsentSaved", "1"); } catch (e) { /* private mode */ }
        /* CAPTCHA-safe submit (2026-08-24): the bare form.submit() we
           used bypassed Shopify's hCaptcha wiring (it hooks the submit
           EVENT after the user interacts with a form FIELD — our form
           only has hidden inputs + the toggle), so the post could
           arrive tokenless and Shopify's risk check bounced it to the
           "Missing CAPTCHA token" error page. Official fix for
           programmatic submits per shopify.dev/docs/storefronts/themes/
           trust-security/captcha: Shopify.captcha.protect(form, cb)
           wires the token, then the plain submit inside the callback
           carries it. Fallbacks (captcha disabled in admin / API
           absent): requestSubmit() still fires the submit event, last
           resort the old direct submit. */
        var plConsentSubmitted = false;
        function plConsentSubmit() {
          if (plConsentSubmitted) return;
          plConsentSubmitted = true;
          if (typeof form.requestSubmit === "function") {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === "function") {
          /* Watchdog: if hCaptcha resources are blocked (ad blocker,
             consent tool, parked script) the protect callback never
             fires and the toggle would hang on "Saving…" forever —
             after 4s we submit anyway (risk-based check usually still
             passes; worst case = the old error page, not a hang). */
          var plCaptchaWatchdog = window.setTimeout(plConsentSubmit, 4000);
          window.Shopify.captcha.protect(form, function () {
            window.clearTimeout(plCaptchaWatchdog);
            if (plConsentSubmitted) return;
            plConsentSubmitted = true;
            form.submit();
          });
        } else {
          plConsentSubmit();
        }
      }, 250);
    };
    consentToggle.addEventListener("change", plConsentSave);
    /* Catch-up (2026-08-24): on slow devices the toggle can be flipped
       BEFORE this deferred file executes — the change event is long
       gone when the listener finally attaches, so the opt-in was
       silently lost (hCaptcha badge showed, nothing saved). The inline
       first-paint script only mirrors the "Saving…" look for that
       window; the actual save runs here the moment we're wired. */
    if (consentToggle.checked) plConsentSave();
  }

  /* Post-consent success note: rendered (hidden) only once accepts_marketing
     is true; shown once right after the consent submit reload. The flag is
     consumed immediately, so any further reload never shows it again; the
     X fades it out. */
  var consentSuccess = root.querySelector("[data-pl-consent-success]");
  if (consentSuccess) {
    var consentJustSaved = false;
    try {
      consentJustSaved = sessionStorage.getItem("plConsentSaved") === "1";
      if (consentJustSaved) sessionStorage.removeItem("plConsentSaved");
    } catch (e) { /* private mode */ }
    if (consentJustSaved) {
      consentSuccess.hidden = false;
      var consentSuccessClose = consentSuccess.querySelector("[data-pl-consent-success-close]");
      if (consentSuccessClose) {
        consentSuccessClose.addEventListener("click", function () {
          consentSuccess.classList.add("is-leaving");
          window.setTimeout(function () { consentSuccess.hidden = true; }, 450);
        });
      }
    }
  }

  /* ---------- Async full order list (Section Rendering API) ----------
     The page render is a fast shell (first 4 orders). The full 20-order
     list + status chips only render when this section is fetched in
     /search context — swap that region in, then re-wire chips and the
     new Buy-again buttons. On failure the shell's first cards stay. */
  var ordersLoading = root.querySelector("[data-pl-orders-loading]");
  if (ordersLoading) {
    fetch(ordersLoading.getAttribute("data-pl-orders-src"))
      .then(function (res) {
        if (!res.ok) throw new Error("orders fetch " + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-pl-orders-region]");
        var region = root.querySelector("[data-pl-orders-region]");
        if (fresh && region) {
          region.innerHTML = fresh.innerHTML;
          wireChips("data-pl-filter-orders", "data-order-status");
          wireBuyAgain(region);
        }
      })
      .catch(function () { /* keep the shell's first cards */ })
      .then(function () {
        /* Swap done (or failed — the shell cards stay): drop the loading
           indicator. Since 2026-08-18 the view is visible the whole time
           (skeleton chips hold the filter row's spot until the swap). */
        ordersLoading.remove();
      });
  }

  /* ---------- Buy again (real ATC) ---------- */
  function wireBuyAgain(scope) {
    scope.querySelectorAll("[data-pl-buy-again]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var variantId = parseInt(btn.getAttribute("data-pl-buy-again"), 10);
      if (!variantId || btn.classList.contains("is-loading")) return;
      var label = btn.textContent;
      btn.classList.add("is-loading");
      btn.textContent = btn.getAttribute("data-label-adding") || "Adding…";

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("ATC failed");
          return res.json();
        })
        .then(function () {
          btn.textContent = btn.getAttribute("data-label-added") || "Added ✓";
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
          var drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.show === "function") {
            drawer.show();
          } else if (drawer) {
            drawer.setAttribute("open", "");
          }
          setTimeout(function () {
            btn.textContent = label;
            btn.classList.remove("is-loading");
          }, 2500);
        })
        .catch(function () {
          btn.textContent = btn.getAttribute("data-label-retry") || "Try again";
          btn.classList.remove("is-loading");
        });
    });
    });
  }
  wireBuyAgain(root);

  /* Init is done — reveal the views that were held back behind a spinner
     because their initial state depends on JS (quiz answers, chip
     activation): ipad + apps. Carousels and chip rows inside re-measure/
     re-park via their ResizeObservers on reveal. */
  root.querySelectorAll("[data-pl-view-pending]").forEach(function (v) {
    v.removeAttribute("data-pl-view-pending");
  });
  /* Chip rows masked by skeleton pills (goodies) go live now — then
     re-activate the current tab once: the row was display:none during
     the programmatic preselect, so filtering/parking must run again on
     the now-visible chips (a size-unchanged reveal doesn't fire the
     ResizeObserver). */
  root.querySelectorAll("[data-pl-chips-pending]").forEach(function (row) {
    row.removeAttribute("data-pl-chips-pending");
  });
  if (goodieChips) {
    var activeGoodieChip = root.querySelector("[data-pl-filter-goodies].is-active");
    if (activeGoodieChip) {
      goodieChips.activate(activeGoodieChip.getAttribute("data-pl-filter-goodies"));
    }
  }
})();
